import { gql } from 'graphql-tag';
import { CONTRIBUTION_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/contribution';
export const CONTENT_SHALLOW_FRAGMENT = `
  fragment ContentShallowFragment on Content {
    __typename
    id
    slug
    name
    description
    availableAt
    cover {
      id
      src
      type
    }
    asset {
      id
      type
      duration
    }
    cachedGrants
  }
`;
export const CONTENT_DEEP_FRAGMENT = `
  ${CONTRIBUTION_SHALLOW_FRAGMENT}
  fragment ContentDeepFragment on Content {
    __typename
    id
    slug
    name
    description
    availableAt
    asset {
      id
      type
      duration
    }
    cover {
      id
      src
      type
    }
    contributions {
      ...ContributionShallowFragment
    }
    chapters {
      id
      name
      location
    }
    cachedGrants
    customFieldsPublic
    customFieldsPrivate
  }
`;
export const CONTENTS_GET = gql `
  ${CONTENT_SHALLOW_FRAGMENT}
  query AllContent {
    allContents {
      ...ContentShallowFragment
    }
  }
`;
export const CONTENT_GET = gql `
  ${CONTENT_DEEP_FRAGMENT}
  query Content (
    $id: ID!
  ) {
    Content(
      id: $id,
    ) {
      ...ContentDeepFragment
    }
  }
`;
export const CONTENT_AND_STREAM_GET = gql `
  ${CONTENT_DEEP_FRAGMENT}
  query ContentAndStream (
    $id: ID!
  ) {
    Content(
      id: $id,
    ) {
      ...ContentDeepFragment
    }
    stream: getContentStream(id: $id)
  }
`;
export const CONTENT_AND_DOWNLOAD_GET = gql `
  ${CONTENT_DEEP_FRAGMENT}
  query ContentAndDownload (
    $id: ID!
  ) {
    Content(
      id: $id,
    ) {
      ...ContentDeepFragment
    }
    download: getContentDownload(id: $id)
  }
`;
export const CONTENT_ASSET_DURATION_GET = gql `
  query ContentAssetDuration($id: ID!) {
    Content(id: $id) {
      id
      asset {
        duration
      }
    }
  }
`;
//# sourceMappingURL=content.js.map